<template>
  <div class="container">
    <Feedback ref="callFeedback" />
    <div class="row">
      <div class="col-md-12 margin-bottom">
        <CompanyHeader :company="this.company" :companyVendors="this.vendors" :companyFinancial="this.finances"/>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <MainContact :mainContact="this.mainContact" :mainContactGroup="this.mainContactGroup" :company="this.company" :enableCallButtons="this.enableCallButtons" :callInProgress="this.callInProgress" :callLocation="this.callLocation" @makeCall="makeCall"/>
        <Dispositions :companyId="this.$route.params.companyId" :lookups="this.lookups" :vendors="vendors" :appointments="appointments"/>
        <Callback :company="company" />
        <CurrentAppointment :appointments="appointments" :vendors="vendors" :companyId="this.$route.params.companyId" :lookups="this.lookups" />
      </div>
      <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Overview" active>
              <b-card-text>
                <CompanyOverview :companyId="this.$route.params.companyId"
                                 :company="this.company"
                                 :mainContact="this.mainContact"
                                 :linkedCompanies="this.linked"
                                 :lookups="lookups"
                                 :statuses="statuses" />
              </b-card-text>
            </b-tab>
            <b-tab title="Contact">
              <b-card-text>
                <CompanyContact :initialCompany="this.company"
                                :lookups="this.lookups"
                                 :initialCompanyVendors="this.vendors"
                                 :enableCallButtons="this.enableCallButtons"
                                 :callInProgress="this.callInProgress"
                                 :callLocation="this.callLocation"
                                 :callResult="this.callResult"
                                 @makeCall="makeCall"/>
              </b-card-text>
            </b-tab>
            <b-tab title="Sector">
              <b-card-text v-if="company">
                <CompanySector :initialCompany="this.company"
                               :lookups="this.lookups" />
              </b-card-text>
            </b-tab>
            <b-tab title="Financial">
              <b-card-text>
                <CompanyFinancial :initialCompany="this.company"
                                  :companyFinancial="this.finances" />
              </b-card-text>
            </b-tab>
            <b-tab title="Qualification" lazy>
              <b-card-text>
                <CompanyPreQualification :lookups="this.lookups" :preQualifications="this.preQualifications" />
                <CompanyQualification :lookups="this.lookups" :qualifications="this.qualifications" />
              </b-card-text>
            </b-tab>
            <b-tab title="Tags">
              <b-card-text>
                <CompanyTags :initialCompany="this.company" :lookups="this.lookups" />
              </b-card-text>
            </b-tab>
            <b-tab title="Suppression">
              <b-card-text>
                <CompanySuppressions :initialCompany="this.company"
                                     :currentUser="this.currentUser"
                                     :companyId="this.$route.params.companyId"
                                     />

              </b-card-text>
            </b-tab>
            <b-tab title="Notes" lazy>
              <b-card-text>
                <CompanyNotes :company="this.company" />
              </b-card-text>
            </b-tab>
            <b-tab title="Documents">
              <b-card-text>
                <CompanyDocuments :company="this.company" />
              </b-card-text>
            </b-tab>
            <b-tab title="History">
              <b-card-text>
                <CompanyHistory :history="this.history" />
              </b-card-text>
            </b-tab>
            <b-tab title="Unbooked" lazy>
              <b-card-text>
                <CompanyUnbooked :lookups="this.lookups" :qualifications="this.qualifications" />
              </b-card-text>
            </b-tab>
            <b-tab title="Client" lazy>
              <b-card-text>
                <CompanyClient :lookups="this.lookups" :initialQualifications="this.qualifications" :company="this.company" />
              </b-card-text>
            </b-tab>
            <b-tab title="Cross Sell">
              <b-card-text>
                <CrossSell :companyId="this.$route.params.companyId"
                           :initialVendors="this.vendors"
                           :lookups="this.lookups"
                           />
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import MainContact from "@/components/company/shared/MainContact.vue";
import Dispositions from "@/components/company/dispositions/Dispositions.vue";
import CompanyHeader from "@/components/company/shared/CompanyHeader.vue";
import CompanyOverview from "@/components/company/overview/CompanyOverview.vue";
import Callback from "@/components/company/dispositions/Callback.vue";
import CompanyContact from "@/components/company/contacts/CompanyContact.vue";
import CompanySector from "@/components/company/CompanySector.vue";
import CompanyHistory from "@/components/company/CompanyHistory.vue";
import CompanyFinancial from "@/components/company/financial/CompanyFinancial.vue";
import CompanyTags from "@/components/company/CompanyTags.vue";
import CompanySuppressions from "@/components/company/suppression/CompanySuppressions.vue";
import CompanyNotes from "@/components/company/notes/CompanyNotes.vue";
import CompanyQualification from "@/components/company/qualification/CompanyQualification.vue";
  import CompanyPreQualification from "@/components/company/prequalification/CompanyPreQualification.vue";
import CompanyUnbooked from "@/components/company/unbooked/CompanyUnbooked.vue";
import CompanyClient from "@/components/company/client/CompanyClient.vue";
  import CompanyDocuments from "@/components/company/documents/CompanyDocuments.vue";
  import CrossSell from "@/components/company/crosssell/CrossSell.vue";
import CompanyService from '@/services/Company.service'
  import LookupsService from '@/services/Lookups.service'
  import CallService from "@/services/Call.service";
  import BookingsService from "@/services/bookings.service";
import CurrentAppointment from "../components/company/shared/CurrentAppointment.vue";
import Feedback from "@/components/shared/Feedback.vue";

export default {
  name: "Company",
  components: {
    MainContact,
    Dispositions,
    CompanyHeader,
    CompanyOverview,
    Callback,
    CompanyContact,
    CompanySector,
    CompanyHistory,
    CompanyFinancial,
    CompanyTags,
    CompanySuppressions,
    CompanyNotes,
    CompanyQualification,
    CompanyPreQualification,
    CompanyUnbooked,
    CompanyClient,
    CompanyDocuments,
    CrossSell,
    CurrentAppointment,
    Feedback,
  },
  data() {
    return {
      company: null,
      finances: null,
      vendors: null,
      mainContact: null,
      mainContactGroup: null,
      lookups: null,
      qualifications: null,
      preQualifications: null,
      linked: null,
      history: null,
      statuses: null,
      currentUser: null,
      enableCallButtons: false,
      appointments: null,
      callInProgress: false,
      callLocation: null,
      callResult: null,
    };
  },
  created() {
    this.loadData();

    LookupsService.loadLookups().then((result) => {
      this.lookups = result.data;
    });
    

  },
  watch: {
    $route: "loadData",
  },
  methods: {
    loadData() {

      CompanyService.loadCompany(this.$route.params.companyId).then((result) => {
        this.company = result.data;
      });

      CompanyService.getCurrentUser().then((result) => {
        this.currentUser = result.data;
      });

      CompanyService.loadCompanyVendors(this.$route.params.companyId).then((result) => {
        this.vendors = result.data;
      });

      CompanyService.loadCompanyHistory(this.$route.params.companyId).then((result) => {
        this.history = result.data;
      });

      CompanyService.loadCompanyFinances(this.$route.params.companyId).then((result) => {
        this.finances = result.data;
      });

      CompanyService.loadMainContact(this.$route.params.companyId).then((result) => {
        if (result.status == 200) {
          this.mainContact = result.data;
        }
      });

      CompanyService.loadMainContactGroup(this.$route.params.companyId).then((result) => {
        this.mainContactGroup = result.data || null;
      });

      CompanyService.loadCompanyQualifications(this.$route.params.companyId).then((result) => {
        //this.qualifications.splice(0);
        //if(this.qualifications == null) {
          this.qualifications = result.data;
        //} else {
        //  this.qualifications.splice(0, result.data)
        //}
        //console.log(this.qualifications)
        //this.qualifications = result.data;
      });

      CompanyService.loadCompanyPreQualifications(this.$route.params.companyId).then((result) => {
        this.preQualifications = result.data;
      });

      CompanyService.getLinkedCompanies(this.$route.params.companyId).then((result) => {
        this.linked = result.data;
      });

      CompanyService.loadSystemsStatuses(this.$route.params.companyId).then((result) => {
        this.statuses = result.data;
      });
      CallService.enableCallButtons().then((result) => {
        //console.log(result);
        if (result.data.enableCallButton) {
          this.enableCallButtons = true;
        }
      });
      BookingsService.getBookingsAppointments(this.$route.params.companyId).then((result) => {
        this.appointments = result.data;
        console.log(result);
      });

    },
    reloadQualificationData() {
      CompanyService.loadCompany(this.$route.params.companyId).then((result) => {
        this.company = result.data;
      });

      CompanyService.loadCompanyQualifications(this.$route.params.companyId).then((result) => {
        this.qualifications = result.data;
      });
      console.log("Reloaded Qual Data")
    },

    reloadLinkedCompanies() {
      CompanyService.getLinkedCompanies(this.$route.params.companyId).then((result) => {
        this.linked = result.data;
      });
    },
    
    reloadCompanyFinances() {
      CompanyService.loadCompanyFinances(this.$route.params.companyId).then((result) => {
        this.finances = result.data;
      });
    },
    async makeCall(number, vendorId, location = 'main') {
      if (this.callInProgress) {
        return;
      }

      this.callInProgress = true;
      this.callLocation = location;
      this.callResult = null;
      this.$refs.callFeedback.clear();
      try {
        const result = await CallService.initiate({ telephoneNumber: number, companyId: this.company.id, vendorId });
        if (result.data.accepted && result.data.provider === 'RingCentralNice' && result.data.url) {
          const http = new XMLHttpRequest();
          http.open('POST', result.data.url);
          http.send();
        }
        this.callResult = result.data;
        if (location === 'main') {
          result.data.accepted
            ? this.$refs.callFeedback.showSuccess('Call', result.data.message)
            : this.$refs.callFeedback.showError('Call', result.data.message);
        }
      } catch (error) {
        const message = error.data && (error.data.message || error.data.title)
          ? error.data.message || error.data.title
          : 'The call could not be started. Please try again.';
        this.callResult = { accepted: false, message };
        if (location === 'main') {
          this.$refs.callFeedback.showError('Call', message);
        }
      } finally {
        this.callInProgress = false;
      }
    }
  },
};
</script>
